import.meta.glob([
    '../images/**/*.png',
    '../images/**/*.jpg',
    '../images/**/*.svg',
    '../fonts/**',
]);

import './bootstrap';

import "./modules/NavMenu";
import "./modules/SwitchableVideoThumbs";
import "./modules/ArchiveFilters";
import "./modules/Lexicon";
import "./modules/MobileSliders";
import "./modules/PasswordChange";
import "./modules/Surveys";
import "./modules/Search";


import SmoothScroll                       from './modules/SmoothScroll';
import Sliders                            from './modules/Sliders';
import ExternalLinks                      from './modules/ExternalLinks';
import Favourites                         from './modules/Favourites';
import LexiconPopup                       from './modules/LexiconPopup';
import ProfileModals                      from './modules/ProfileModals';
import Profile                            from './modules/profile/Profile';
import Form                               from "./modules/form/Form";
import ToggleAudioEmbeds                  from './modules/ToggleAudioEmbeds';
import FunkyBackgroundsControl            from './modules/FunkyBackgroundsControl';
import EcrisNous                          from "./modules/EcrisNous";


// Vue
import "./modules/quiz/quiz";
import "./modules/comments/comments";
import "./modules/login/login";
import './modules/SidebarFilters';
import './modules/IsRead';
// import './modules/LastSeenPosts';
import BroadcastUserInfo                  from "./modules/BroadcastUserInfo";
import HeaderUser                         from "./modules/HeaderUser";
import Toasts                             from './modules/Toasts';
import ShowMore                           from './modules/ShowMore';
import Search                             from "./modules/Search";
import Authors                            from "./modules/Authors";
import { checkIfUsingCorrectAssetsBuild } from './modules/Utils';
import SuggestedPosts                     from './modules/SuggestedPosts';
import Ads                                from './modules/Ads';


document.addEventListener( 'DOMContentLoaded', () =>
{

    let body     = document.querySelector( 'body' );
    let pageId   = (body.attributes[ "data-page-id" ].value ?? "");
    let pageName = (body.attributes[ "data-page-name" ] ?? { value : "" }).value ?? "";

    const profileModals = new ProfileModals();

    const lexiconPopup = new LexiconPopup();
    const smoothScroll = new SmoothScroll();

    const externalLinks     = new ExternalLinks();
    const favourites        = new Favourites();
    const toggleAudioEmbeds = new ToggleAudioEmbeds();

    if ( [ 'user-profile' ].includes( pageId ) )
    {
        Profile.launch();

    } else if ( [ 'page-single' ].includes( pageId ) && [ 'écris-nous' ].includes( pageName ) )
    {
        new EcrisNous();

    } else if ( [ 'verification' ].includes( pageId ) )
    {
        let bui = new BroadcastUserInfo();
        bui.broadcastEmail();

    } else if ( [ 'author-post-archive' ].includes( pageId ) )
    {
        new Authors();
    }


    // sliders
    const foundSliders = document.querySelectorAll( '.always-swiper' );
    if ( foundSliders )
    {
        Array.from( foundSliders ).forEach( fs => new Sliders( fs ) );
    }

    new Search();
    new HeaderUser();


    let forms = Array.from( document.querySelectorAll( "[data-form]" ) );

    forms.forEach( ( form ) =>
    {
        let strSelector = form.attributes[ "id" ].value;
        let strId       = form.attributes[ "data-form-id" ].value;
        //let formJson    = window[ "__form_" + strId + "__" ];

        Form.launch( "#" + strSelector, strId );
    } )

    // console.log( 'app.js has loaded its modules', pageId );


    let showMoreGroups = document.querySelectorAll( '.show-more-toggler' );
    if ( showMoreGroups.length > 0 )
    {
        Array.from( showMoreGroups ).forEach( group =>
        {
            const showMoreGroup = new ShowMore( group );
        } );
    }

    const ads = new Ads();

    // checkIfUsingCorrectAssetsBuild( __BUILD_TYPE__ );
} );


// not a priority, let everything else do its thang
window.addEventListener( 'load', () =>
{

    const toasts = new Toasts();

    const funkyBackgroundsControl = new FunkyBackgroundsControl();

    const suggestedPosts = new SuggestedPosts();
} )


console.log( "%c Les AS de l'info par : %c %c" + " Les Coops de l'information ", "background-color:#d71825;color:white;padding:10px", "background-color:white; color:#d71825;padding:10px", "background-color:#d71825;color:white;padding:10px" );
console.log( "%c Développé par        : %c %c" + " https://lesaffranchis.ca   ", "background-color:#48aa47;color:white;padding:10px", "background-color:white; color:#d71825;padding:10px", "background-color:#48aa47;color:white;padding:10px" );
console.log( "%c Date de compilation  : %c %c" + __VITE_COMPILATION_DATE__, "background-color:#d71825;color:white;padding:10px", "background-color:white; color:#d71825;padding:10px", "background-color:#d71825;color:white;padding:10px" );



